import { ProcessedData } from "../../modules/feedManager/store/types";
import { createQuoteFeedersTable } from "./quoteFeeders";
import { createSecuritiesTable } from "./securitiesTable";

interface CreateDataSourceTablesArgs {
  context: Excel.RequestContext;
  data: ProcessedData;
}

export const createDataSourceTables = async ({ context, data }: CreateDataSourceTablesArgs) => {
  createSecuritiesTable({ context, securities: data.securities });
  await context.sync();
  createQuoteFeedersTable({ context, quoteFeeds: data.quote_feeds });
  await context.sync();
};
